module.exports = __webpack_public_path__ + "img/sloneczny_brzeg.91489308.jpg";